import { cva } from 'class-variance-authority';

export const nextArrowStyles = cva([
  'next-arrow',
  'absolute',
  'bottom-5',
  'right-5',
  'top-0',
  'z-10',
  'm-auto',
  'hover:cursor-pointer',
  'lg:-right-5',
  'xxl:-right-10',
  'hidden',
  'md:flex',
]);

export const prevArrowStyles = cva([
  'prev-arrow',
  'absolute',
  'bottom-5',
  'left-5',
  'top-0',
  'z-10',
  'm-auto',
  'hover:cursor-pointer',
  'lg:-left-5',
  'xxl:-left-10',
  'hidden',
  'md:flex',
]);

export const titleStyles = cva([
  'absolute',
  'inset-x-0',
  'z-10',
  'text-center',
  'font-bold',
  'text-white',
  'text-2xl',
  'lg:left-32',
  'xl:left-[85px]',
  'lg:text-left',
  'top-[50px]',
  'sm:top-[60px]',
  'lg:top-[70px]',
]);

export const slideContainer = cva([
  'speaker',
  'bg-blue-900',
  'px-8',
  'pb-4',
  'pt-8',
  'text-center',
  'lg:text-left',
  'xl:px-14',
  'md:px-24',
  'md:pb-0',
]);

export const slideInnerContainer = cva(['mt-14', 'flex', 'w-full', 'flex-col', 'items-center', 'lg:flex-row']);

export const headshotStyles = cva([
  'mb-5',
  'lg:mb-0',
  'h-[200px]',
  'w-[200px]',
  'md:h-[265px]',
  'md:w-[265px]',
  'rounded-full',
  'object-cover',
  'lg:mr-10',
]);
